<template>
  <div>
    <div class="back">
      <div class="them">工程造价咨询业信息管理</div>
      <div class="themR">
        Yunnan Province Engineering Cost Consulting Industry Information
        Management System
      </div>
    </div>
    <div class="bodyControll">
      <div v-if="userinfo">
        <div class="remark">
          <img src="@/assets/img/warn.png" alt="" /><span class="text"
        >您好，欢迎来到工程造价咨询业信息管理，立即前往</span
        >&nbsp;&nbsp;<span class="record" @click="goRecord">个人中心</span>
        </div>
      </div>
      <div v-else class="enterControll">
        <div class="enter">
          <div class="border blue"></div>
          <div class="cont">
            <div class="contT">
              <img src="@/assets/img/home1.png" alt="" />
              <div class="enterT">工程造价咨询业企业</div>
            </div>
                        <div @click="goLogin()" class="btn blue">登录</div>
<!--            <div @click="msg" class="btn blue">登录</div>-->
          </div>
        </div>
        <div class="enter" style="margin-left: 20px">
          <div class="border organ"></div>
          <div class="cont">
            <div class="contT">
              <img src="@/assets/img/home2.png" alt="" />
              <div class="enterT">管理机构</div>
            </div>
            <div class="btn organ">
              <a
                href="http://zjqyadmin.ynbzde.com/admin.html"
                target="_blank"
                class="link"
              >登录</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="searchControll">
        <div class="searchH">
          <div class="lf">
            <img src="@/assets/img/home_mini.png" alt="" />
            <div class="searchT">工程造价咨询业公共服务查询</div>
          </div>
          <div class="lf">
            <el-form
              ref="form"
              :rules="rules"
              :model="form"
              class="formControll"
              style="margin-left: 40px"
            >
              <el-form-item prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入企业名称"
                ></el-input>
              </el-form-item>
              <!--            <el-form-item prop="code" style="margin-left: 10px">-->
              <!--              <el-input-->
              <!--                v-model="form.code"-->
              <!--                placeholder="请输入统一社会信用代码证号"-->
              <!--              ></el-input>-->
              <!--            </el-form-item>-->
            </el-form>
            <div class="searchB" @click="search()">查询</div>
          </div>
        </div>
        <div class="tableControll">
          <div class="tableHeader">
            <span>企业名称</span>
            <span>企业类型</span>
            <span>经济类型</span>
            <span>登记状态</span>
            <span>通过时间</span>
          </div>
          <div v-if="listData && listData.length">
            <vue-seamless-scroll :data="listData" class="warp">
              <ul class="item">
                <li v-for="(item, index) in listData" :key="index">
                  <span v-text="item.name"></span>
                  <span v-text="item.com_type"></span>
                  <span v-text="item.eco_type"></span>
                  <span v-text="item.reg_status"></span>
                  <span v-text="item.update_time"></span>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <div v-else class="empty">
            <img src="@/assets/img/home_k.png" alt="" class="empty" />
            <div class="emptyT">暂无已完成信息登记的企业</div>
          </div>
          <!--          <el-table :data="tableData1" style="width: 100%">-->
          <!--            &lt;!&ndash;缺省&ndash;&gt;-->
          <!--            <template slot="empty">-->
          <!--              <img src="@/assets/home_k.png" alt="" class="empty">-->
          <!--              <div class="emptyT">暂无已完成信息登记的企业</div>-->
          <!--            </template>-->
          <!--            <el-table-column prop="date" label="企业名称" width="350">-->
          <!--            </el-table-column>-->
          <!--            <el-table-column prop="name" label="企业类型" width="200">-->
          <!--            </el-table-column>-->
          <!--            <el-table-column prop="address" label="经济类型" width="230"></el-table-column>-->
          <!--            <el-table-column prop="style" label="登记状态" width="220"></el-table-column>-->
          <!--            <el-table-column prop="time" label="通过时间"></el-table-column>-->
          <!--          </el-table>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vueSeamlessScroll from "vue-seamless-scroll";
import { search, rangeCompanyList } from "@/api/index.js";

export default {
  name: "index",
  components: {
    vueSeamlessScroll
  },
  computed: {
    ...mapState(["userinfo"])
  },
  created() {
    this.listShow();
  },
  data() {
    return {
      pages: {
        //默认起始页、一页多少条
        page: "",
        limit: ""
      },
      id: "", //查询后获得企业id
      form: {
        name: ""
        // code: "",
      },
      rules: {
        // code: [
        //   {
        //     required: true,
        //     message: "请输入统一社会信用代码证号",
        //     trigger: "blur",
        //   },
        // ],
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }]
      },
      listData: []
    };
  },
  methods: {
    //消息提示
    msg() {
      this.$message({
        message: "系统更新中",
        type: "error"
      });
    },
    //个人中心
    goRecord() {
      this.$router.push({ name: "homeIndex" });
    },
    goLogin() {
      this.$router.push({ name: "login" });
    },

    //列表滚动
    async listShow() {
      const res = await rangeCompanyList(this.pages);
      this.listData = res;
    },
    search() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const res = await search(this.form);

            this.name = res.name;
            // this.code = res.code;
            this.$message.success("查询成功！");
            this.$router.push({
              name: "result",
              query: { name: this.name }
            });
          } catch (error) {
            // this.$message.error(error.msg);
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.back {
  background-image: url("~@/assets/img/home_logo.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 220px;
  padding-top: 68px;
  box-sizing: border-box;

  .them {
    display: flex;
    justify-content: center;
    font-size: 44px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 58px;
    letter-spacing: 0.88px;
    text-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
  }

  .themR {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    height: 17px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0.32px;
    text-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
  }
}

.bodyControll {
  width: 1200px;
  margin: auto;
  margin-top: 20px;

  .remark {
    background: #f9f4e8;
    border: 1px solid rgb(252, 223, 155);
    border-radius: 2px;
    margin-top: 23px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    height: 32px;

    img {
      width: 13px;
      height: 13px;
    }

    .text {
      font-size: 12px;
      color: #333333;
      margin-left: 5px;
    }

    .record {
      font-size: 12px;
      color: rgb(243, 149, 42);
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .enterControll {
    display: flex;

    .enter {
      background: #fff;
      flex: 1;
      padding: 22px 20px;
      position: relative;
      box-shadow: 0px 0px 6px 0px rgba(151, 190, 255, 0.2);

      .border {
        position: absolute;
        top: 0px;
        right: 0px;
        left: 0px;
        flex: 1;
        height: 7px;
        border-radius: 2px 2px 0px 0px;
      }

      .blue {
        background: #4379f6;
      }

      .organ {
        background: #fc7546;
      }

      .cont {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .contT {
          display: flex;
          align-items: center;

          img {
            width: 33px;
            height: 36px;
          }

          .enterT {
            margin-left: 17px;
            font-size: 22px;
            color: #333333;
          }
        }

        .btn {
          cursor: pointer;
          width: 128px;
          height: 36px;
          border-radius: 2px;
          font-size: 14px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
        }
      }
    }
  }

  .searchControll {
    margin-top: 20px;
    height: 490px;
    background: #ffffff;
    border-radius: 2px;
    box-shadow: 0px 0px 6px 0px rgba(151, 190, 255, 0.2);
    padding: 32px 20px;
    box-sizing: border-box;

    .searchH {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .lf {
        display: flex;
        align-items: center;
      }

      img {
        width: 22px;
        height: 22px;
      }

      .searchT {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Regular;
        color: #333333;
        margin-left: 7px;
      }

      .formControll {
        display: flex;
        align-items: center;
      }

      .searchB {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        width: 70px;
        height: 36px;
        background: #4379f6;
        border-radius: 2px;
        margin-left: 10px;
        cursor: pointer;
      }

      /deep/ .el-form-item {
        margin-bottom: unset;
      }

      /deep/ .el-input__inner {
        width: 370px;
      }

      /deep/ .el-input__inner:hover {
        border-color: #4379f6;
      }
    }

    .tableControll {
      margin-top: 32px;
      height: 225px;

      .tableHeader {
        height: 40px;
        background: #f6f6f6;
        box-shadow: 0px 1px 0px 0px #e6e6e6;
        display: flex;
        align-items: center;

        span {
          font-size: 12px;
          color: #666666;

          &:nth-child(1) {
            flex: 2;
            text-align: left;
            padding-left: 20px;
          }

          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4) {
            flex: 1;
          }

          &:nth-child(5) {
            flex: 1;
            text-align: center;
            //padding-right: 20px;
          }
        }
      }

      .empty {
        width: 210px;
        height: 134px;
        margin: auto;
        margin-top: 75px;
        display: block;
      }

      .emptyT {
        font-size: 14px;
        text-align: center;
        color: #999999;
        letter-spacing: 0.7px;
        margin: 30px 0 0;
      }

      .warp {
        height: 345px;
        overflow: hidden;

        li {
          border-bottom: 1px dashed #ddd;
          padding: 12px 0 10px;
          display: flex;

          span {
            font-size: 12px;
            color: #333333;

            &:nth-child(1) {
              flex: 2;
              text-align: left;
              padding-left: 20px;
            }

            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4) {
              flex: 1;
            }

            &:nth-child(5) {
              flex: 1;
              text-align: right;
              padding-right: 20px;
            }
          }
        }
      }

      //
      ///deep/ .el-table th {
      //  background: #f6f6f6 !important;
      //  color: #666;
      //  font-weight: normal;
      //}
      //
      ///deep/ .el-table tr {
      //  color: #333 !important;
      //  font-size: 12px;
      //}
      //
      ///deep/ .el-table__empty-text {
      //  line-height: unset;
      //}
    }
  }
}

//自定义滚动条
//
//::-webkit-scrollbar {
//  width: 8px;
//  height: 16px;
//  background-color: #f5f5f5;
//}
//
///*定义滚动条轨道 内阴影+圆角*/
//::-webkit-scrollbar-track {
//  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//  border-radius: 10px;
//  background-color: #f5f5f5;
//}
//
///*定义滑块 内阴影+圆角*/
//::-webkit-scrollbar-thumb {
//  border-radius: 10px;
//  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//  background-color: rgb(193, 193, 193);
//}
.link {
  color: #fff;
  text-decoration: unset;
}
</style>
